<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/ADC4/ADC4.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">ADC3.0 Driving Domain Controller</div>
                <div class="detail-banner-desc">Based on the Orin Y platform, this advanced driver assistance system integrates end-to-end models that unify perception, prediction, planning and other core functions.</div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>

                    <div class="detail-desc">
                        <div>
                            Orin Y Platform.
                        </div>
                        <div>
                            Intelligent driving assistance that integrates perception, prediction, planning and other models through an end-to-end model.
                        </div>
                        <div>
                            5 radars, 11 cameras, 12 ultrasonic radars, 1 LIDARs.
                        </div>
                        <div>
                            Centimeter-level high-precision positioning.
                        </div>
                        <div>
                            Liquid cooling.
                        </div>
                        <div>
                            Functional safety: ASIL B.
                        </div>
                        <div>
                            Function: Urban NOA, Freeway NOA, VPA.
                        </div>

                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/ADC4/ADC4-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">9-16V</div>
                                    <div class="k">Operating voltage range</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">13.5V</div>
                                    <div class="k">Working voltage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">≤0.5mA</div>
                                    <div class="k">Static current</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">32GB+128GB</div>
                                    <div class="k">Storage</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">200 TOPS</div>
                                    <div class="k">Computing power</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: 'ADC3.0 Driving Domain Controller - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics/ADC3.html'
};

import { createApp } from 'vue';
import App from './ADC3.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./ADC3.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
